import React from 'react';
import { Modal, Form, Input, Button, Row, Col, message} from 'antd';
import { ResetPasswordRequest } from '../constant';
import { ResetPassword } from '../api/ResetPassword';

interface ResetPasswordModalProps {
    visible: boolean;
    onCancel: () => void;
  }
  
const ResetPasswordModal: React.FC<ResetPasswordModalProps> = ({ visible, onCancel }) => {
  const [form] = Form.useForm();

  const onFinish = (resetrequest: ResetPasswordRequest) => {

    ResetPassword(resetrequest)
        .then((resetresponse) => {
          if (resetresponse.success)
          {
            message.success("Reset Password Success")
          }
          else{
            message.error(resetresponse.msg)
          }
        })
        .catch((error) => {
          console.error("An error occurred:", error.message);
          return
        });   
    
    form.resetFields();  
    onCancel();  
  };

  return (
    <Modal
      open={visible}
      title="Reset Password"
      className='register-text-style'
      onCancel={onCancel}
      footer={null}
      width={600}
    >
      <div className='text-xs'>
        Please enter the required information below to reset your password.
        If you do not have this information please call our office for assistance at 602-279-6344
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          username: 'test1234',
          emailAddress: 'ttt123@ggg.com',
          licenseNumber: '71572',
          password: '123qwe',
          password2: '123qwe'
        }}
        style={{ marginTop: 20 }}
      >

        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label> Username : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="username"
              rules={[{ required: true, message: 'Please input your requested username!' }]}
            >
              <Input className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>
        {/* Email Address and License Number */}
        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>Email Address : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="emailAddress"
              rules={[
                { required: true, message: 'Please input your email address!' },
                { type: 'email', message: 'Please input a valid email address!' },
              ]}
            >
              <Input className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>License Number : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="licenseNumber"
              rules={[{ required: true, message: 'Please input your license number!' }]}
            >
              <Input className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>
        {/* Password and Re-enter Password */}
        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>Password : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Please input your password!' }]}
            >
              <Input.Password className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>Re-enter Password : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="password2"
              dependencies={['password']}
              rules={[
                { required: true, message: 'Please reenter your password!' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('The passwords do not match!'));
                  },
                }),
              ]}
            >
              <Input.Password className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>

        <div  className='justify-items-center'>
            <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '200px'}}>
                Reset
            </Button>
            </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};


export default ResetPasswordModal;